/*
 * @Description:
 * @Date: 2024-11-29 11:37:12
 */
import { RoleType } from '@/common/constants/user';
import { getUserUnsignedContract } from '@/common/data-source/common/apis';
import appStore from '@/store';
import { useSetup } from '@/store/modules/user';
import { storeToRefs } from 'pinia';
import { XrkMessageBox } from 'xrk-components';
import { route as contractRouter } from '@/views/contract-mgmt/src/router';
import { WHITE_LIST } from '@constants/intercept';

export default async (router, to) => {
  // 独立页（白名单）不进主应用签约拦截
  if (WHITE_LIST.includes(to.path)) {
    return Promise.resolve();
  }
  // 跳转到合同页面不弹
  const whiteInterceptor = contractRouter.map(item => item.path);
  if (whiteInterceptor.includes(to.path)) {
    return Promise.resolve();
  }
  const { info, defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);
  // 弹出合同签约提醒标识 shouldShowContractSign
  if (!info.value.shouldShowContractSign) {
    return Promise.resolve();
  }
  const loginStore = useSetup();

  await getUserUnsignedContract().then(async ({ data }) => {
    const { notSignedTotal, mustSignTotal } = data;
    loginStore.setInfo({
      ...info.value,
      shouldShowContractSign: mustSignTotal === 1
    });
    // mustSignTotal 是否必拦截签署 企业-企业 （线上） 1必拦截 0非必拦截
    // notSignedTotal 未签约的总数
    if (!notSignedTotal) {
      return;
    }
    await XrkMessageBox.confirm(
      `您有${notSignedTotal}个新的电子合同需要签约，未避免影响项目执行请您及时签约`,
      '签约提醒',
      {
        confirmButtonText: '去签约',
        cancelButtonText: '稍后签约',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showCancelButton: !(mustSignTotal === 1)
      }
    ).then(() => {
      const contractPrefix = {
        [RoleType.INDUSTRY]: 'industry',
        [RoleType.ASP]: 'asp',
        [RoleType.DBGYS]: 'dbgys',
        [RoleType.SUPPLIER]: 'supplier'
      };

      router.push(
        `/main/${
          contractPrefix[+defaultUserFnCode.value]
        }/contract-mgmt/list?tab=${data[0]?.type}`
      );
    });
  });
  return Promise.resolve();
};
